





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AttachmentList, { AttachmentItem } from '@/components/attachmentList/index.vue';
import { FormModel } from 'ant-design-vue';
import { translateRenderVNode } from '@/utils/language';

@Component({
  components: {
    AttachmentList,
  },
})
export default class AddEditModal extends Vue {
  /** 父组件传入参数 */
  @Prop({ type: Object, default: () => ({}) })
  private data!: TypeProductMaintenanceComplianceOfficer.ListDataItem;
  private visible: boolean = false;
  /**
   * 根据进口国过滤合规负责人
   * 英国只能选择英国的合规负责人
   * 欧盟国只能选择欧盟国的合规负责人
   */
  private get filterComplianceOfficerList(): TypeProductComplianceOfficer.ListDataItem[] {
    return this.complianceOfficerList.filter((item) => item.country_code === this.$enum.common.CountryEnum.GB);
  }
  /** 合规负责人列表 */
  private complianceOfficerList: TypeProductComplianceOfficer.ListDataItem[] = [];
  /** 表单数据 */
  private formData: TypeProductMaintenanceComplianceOfficer.FormData = this.initFormData();
  /** 表单校验规则 */
  private formDataRule: TypeCommon.CommonFormRules = {
    'product_sku': [{ required: true, message: this.t('请选择商品编码'), trigger: 'change' }],
    '_compliance_officer_id': [{ required: true, message: this.t('请选择合规负责人'), trigger: 'change' }],
  };
  /** 待操作部分提示语 */
  private get getTipsHtml() {
    const h = this.$createElement;
    return <div class="note-tip">
      {translateRenderVNode(h,
        this.t('无可用合规负责人，前往{0}页面新增英国负责人。 '),
        [
          <a onClick={
            () => {
              this.visible = false;
              this.$router.push({
                name: 'ComplianceOfficer',
              })
            }
          }>{this.t('合规负责人维护')}</a>
        ])}
    </div>;
  }
  /**
   * 关闭弹窗
   */
  private handleClose() {
    this.visible = false;
  }
  /**
   * 初始化表单数据
   */
  private initFormData(): TypeProductMaintenanceComplianceOfficer.FormData {
    const data = this.data?.current_compliance_officer?.[0];
    return {
      compliance_officer_id_list: data?.id ? [data?.id as string] : [],
      _compliance_officer_id: data?.id,
      id: this.data?.id,
      product_eu_uk_type: this.data?.product_eu_uk_type,
      product_sku: this.data?.product_sku,
      import_country: this.data?.import_country,
      import_country_name: this.data?.import_country_name,
    };
  }
  /**
   * 获取合规负责人列表
   */
  private async queryComplianceOfficerList(): Promise<void> {
    const res = await this.$api.product.queryComplianceOfficerAll<TypeBase.ListResult<TypeProductComplianceOfficer.ListDataItem[]>>({
      status: this.$enum.product.ComplianceOfficerStatusEnum.AUDIT_PASSED,
    });
    if (res.code === 0) {
      this.complianceOfficerList = res.data.list;
    }
  }
  /**
   *  确定
   */
  private async handleOk() {
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate(async (valid: boolean): Promise<void | undefined> => {
      if (!valid) {
        return;
      }
      const params = this.$util.deepCopy(this.formData);
      params.compliance_officer_id_list = !this.$util.isEmpty(params._compliance_officer_id) ? [params._compliance_officer_id as string] : [];
      const res = await this.$api.product.updateMaintenanceComplianceOfficer({ list: [params] });
      if (res.code === 0) {
        this.$message.success('操作成功');
        this.$emit('success');
        this.handleClose();
      }
    });
  }
  private created(): void { }
  /**
   * 监听弹窗显示情况
   */
  @Watch('visible', { immediate: true })
  private async handleVisibleChange(value: number): Promise<void> {
    this.queryComplianceOfficerList();
    if (value) {
      this.formData = this.initFormData();
    } else {
      const formDataRef = this.$refs.formDataRef as FormModel;
      formDataRef && (formDataRef as any).clearValidate();
    }
  }
}
